import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';


/**
 * Custom element that displays a variant-reactive delivery estimate.
 *
 * Listens for VariantUpdateEvent on the closest shopify-section (or dialog) and
 * morphs its own children from the freshly server-rendered section HTML,
 * mirroring the pattern used by product-price and product-inventory.
 */
class DeliveryEstimate extends Component {
  connectedCallback() {
    super.connectedCallback();
    const section = this.closest('.shopify-section, dialog');
    section?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const section = this.closest('.shopify-section, dialog');
    section?.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  /**
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  #handleVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const newElement = event.detail.data.html.querySelector(
      `delivery-estimate[data-block-id="${this.dataset.blockId}"]`
    );

    if (!newElement) return;

    morph(this, newElement, { childrenOnly: true });
  };
}

if (!customElements.get('delivery-estimate')) {
  customElements.define('delivery-estimate', DeliveryEstimate);
}
